import React, {useState} from 'react';
import {useLocation} from "react-router-dom";
import ReactModal from 'react-modal';
import { useSystemMessage } from '../../../../hooks/useSystemMessage';
import useLoading from '../../../../hooks/useLoading';

import { userApi } from '../../../../apis/admin/user/userApi';

import { DeleteUserModalParams } from '../../../../types/admin/account';
import {ApiClientError} from "../../../../apis/errors";
import useAppRouter from "../../../../hooks/useAppRouter";
import {logError} from "../../../../libs/utils/logError";


interface DeleteCustomerModalProps {
  modalParams: DeleteUserModalParams | undefined;
  onSubmitted: (isChange: boolean) => Promise<void>;
}

export const DeleteCustomerModal = (props: DeleteCustomerModalProps) => {
  const { modalParams, onSubmitted } = props;

  const withLoading = useLoading();
  const location = useLocation();
  const { success } = useSystemMessage();
  const [ apiClientError, setApiClientError] = useState<ApiClientError | null>(null);
  const { goto } = useAppRouter();


  const handleChangeState = async () => {
    withLoading(async () => {
      setApiClientError(null);

      try {
        await userApi.deleteCustomer(
          modalParams!.userId,
          {}
        );

        await onSubmitted(true);
        await success(`${modalParams!.userName} を削除しました。`);

      } catch (e) {
        await logError(
          location.pathname,
          'アカウントの削除に失敗しました。',
          e
        );

        if (e instanceof ApiClientError) {
          setApiClientError(e);
          return;
        }

        goto('internalServerError');
      }
    });
  };

  return (
    <>
      <ReactModal
        isOpen
        ariaHideApp={false}
        onRequestClose={() => onSubmitted(false)}
        className="w-1/3"
        overlayClassName="overlay"
        shouldCloseOnOverlayClick
        style={{
          content: {
            position: 'fixed',
            top: '1rem'
          }
        }}
      >
        <section className="modal-background">
          <div className="form-modal-container">
            <div className="form-modal-title">
              <h1 className="font-semibold">確認</h1>
              <button
                type="button"
                className="modal-close-btn"
                onClick={() => onSubmitted(false)}
              >
                ×
              </button>
            </div>
            <div className="form-modal-content">
              <div className="mb-4 text-danger text-xs">
                { apiClientError?.message }
              </div>

              <div className="text-primary text-sm font-semibold grid grid-cols-1 w-full break-all">
                <p>
                  { modalParams !== undefined ? modalParams.userName : "" } を削除します。
                </p>
                <p>よろしいですか？</p>
                <p className="text-danger mt-4">※ 削除したアカウントは元に戻すことができません。</p>
              </div>
            
            </div>
            <div className="form-modal-footer-container">
              <div className="form-modal-footer">
                <button
                  className="btn-sub"
                  type="button"
                  onClick={() => onSubmitted(false)}
                >
                  キャンセル
                </button>
                <button
                  className="btn-primary"
                  type="button"
                  onClick={() => handleChangeState()}
                >
                  削 除
                </button>
                
              </div>
            </div>
          </div>
        </section>
      </ReactModal>
    </>
  );
}